import type { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import Delivery from './partial/Delivery';

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
}

const ShippingOptionsUpdatedModal: FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        title="Entregas actualizadas"
      />
      <ModalBody className="co-flex co-flex-col co-gap-4 tablet:co-min-h-[244px]">
        <div className="co-flex co-flex-col">
          <div className="co-pt-[16px] co-flex co-flex-col co-p-3 co-pb-0 co-items-center co-text-center">
            <Delivery />
            <Text variant="body1" weight={400} className="co-mt-[40px]">
              Al cambiar tu dirección, actualizamos tus opciones de
              <Text variant="body1" weight={600} className="co-text-balance">
                {' '}
                retiro y despacho
              </Text>
              . Revisa que todo esté correcto antes de continuar.
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter
        className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit"
        primaryButton={{
          label: 'Entendido',
          onClick: onClose
        }}
      ></ModalFooter>
    </Modal>
  );
};

export default ShippingOptionsUpdatedModal;
